import React, {
	Component,
	Fragment
} from 'react';
import { connect } from 'react-redux';
import urlJoin from 'url-join';
import classNames from 'classnames';
import { sprintf } from 'sprintf-js';

import {
	AppState,
	TargetType,
	Origin,
	Position
} from './store/appMode';
import BuilderControls from './containers/BuilderControls/BuilderControls';
import PullOutPanel from './containers/PullOutPanel/PullOutPanel';
import StepEdit from './containers/StepEdit/StepEdit';
import TargetSelector, { TargetSelectorMode } from './components/TargetSelector/TargetSelector';
import * as actions from './store/actions/index';
import * as actionTypes from './store/actions/action-types';
import Popup from './components/Popup/Popup';
import Button from './components/Button/Button';
import MobileViewPopup from './../../../../../includes/assets/js/modules/MobileViewPopup';
import MobileMenuOptionsVisualBuilderLoader from '../../../../../includes/assets/js/modules/MobileMenuOptionsVisualBuilderLoader';
import Cookies from 'js-cookie';
import {
	getTransitionDurationMs
} from '../../modules/dpitUtilsPublic';
import {
	simpleObjectToStr,
	buildDpQueryString,
	absToRelativeUrl,
	encodeStepParamAdvancedVal,
	sanitizePossibleRelativeUrl,
	removeURLParameters,
	getNthStr,
	isVariableUrl,
	isUrlAtOurSite,
	asyncWait
} from '../../../../../includes/assets/js/modules/dpitUtilsInc';

import FiveStarImage from './../../../../../includes/assets/images/5-stars-500x116.png';
import {
	CLASSES_CORE,
	EVENTS,
	REFRESH_REASONS,
	RESPONSIVE_MODE
} from '../../modules/core/constants';

import DpWpLink from '../../../../../includes/assets/js/modules/DpWpLink';
import DpTinyMceDialog from '../../../../../includes/assets/js/modules/DpTinyMceDialog';

import './dpit-b-common-styles.scss';


const i18n = window.dpIntroTourPublicConfig.i18n;

class App extends Component {

	constructor(props) {
		super(props);
		this.lastStepElement = null;
		this.dpWpLink = null;
		this.mobileViewPopup = new MobileViewPopup(this.onMobileViewPopupExit, props.mainCfg);
		this.mobileMenuOptionVisualBuilderLoader = new MobileMenuOptionsVisualBuilderLoader(props.mainCfg);

		if (props.mainCfg.dpWpLink) this.dpWpLink = new DpWpLink(props.mainCfg.dpWpLink);
		if (props.mainCfg.dpDebugEn) console.log('[dpit] INIT Builder main App');
		this.pullOutPanelRef = React.createRef();
	}

	componentDidMount() {

		if (this.props.core) {
			this.props.core.subscribeEvent(EVENTS.ended, () => {
				this.updateCurrentStepData({});
				this.props.setStepChangingInProgress(false);
				return true;
			});
			this.props.core.subscribeEvent(EVENTS.onOverlayClick, () => {
				if (this.props.appState === AppState.PANEL_EDIT) {
					this.props.setAppState(AppState.VIEW);
				}
			});

			this.props.core.subscribeEvent(EVENTS.onNoStepsInit, () => {
				this.props.setAppState(AppState.VIEW);
				//if (this.tmce) this.tmce.showOverlay();
			});


			// After step changed
			this.props.core.subscribeEvent(EVENTS.afterStepChange, (args) => {
				if (args.isStickyTheme && !args.isStickyThemeOnTop && this.props.appState !== AppState.TARGET_SELECTION) {
					this.props.setControlsPosition(Position.TOP);
				}
				else {
					this.props.setControlsPosition(Position.BOTTOM);
				}
				this.updateCurrentStepData(args.currentStepObj);
				this.props.setStepChangingInProgress(false);
				if (this.setTargetSelectionModeAfterStep) {
					this.setTargetSelectionModeAfterStep = false;
					//this.onTargetSelectionStarted(true);
					this.props.setAppState(AppState.TARGET_SELECTION);
				}
				if (this.props.isPRO && args.currentStepObj && this.props.secondLayerIntroModule) {
					let url = this.props.secondLayerIntroModule.preprocessStepUrl(args.currentStepObj.url, args.currentStepObj.idx);
					let absUrl = sanitizePossibleRelativeUrl(url, this.props.mainCfg.siteUrl);
					if (!isUrlAtOurSite(absUrl, this.props.mainCfg.siteUrl) && !this.props.secondLayerIntroModule.isKeepVarUrl(args.currentStepObj.url)) {
						this.props.updateHint({
							active: true,
							type: 'info',
							pulse: true,
							dismissible: true,
							title: i18n.redirecting_ext_q,
							desc: i18n.ext_url_current_step + ' ' + i18n.ext_url_not_redirect
						});
					}
				}

				return true;
			});

			this.props.core.subscribeEvent(EVENTS.beforeStepChange, () => {
				this.props.closeHint();
				this.props.setStepChangingInProgress(true);
				return true;
			});

			this.props.core.subscribeEvent(EVENTS.started, () => {
				if (this.props.targetType === TargetType.STEP) {
					if (this.tmce) this.tmce.hideOverlay();
					this.props.setStepCount(this.props.core.stepItems.length);
					if (this.props.mainCfg.mobileAltStepMode) {
						// TODO	this.props.core.resetTarget(false);
					}
					else {
						this.props.setAppState(this.props.mainCfg.initState || AppState.VIEW);
					}
				}
			});

			this.props.core.subscribeEvent(EVENTS.onButtonHover, (args) => {
				this.props.setNavigButtonHoveredState(args.id, args.hoverIn);
			});
		}

		this.pullOutPanelTransitionMs = getTransitionDurationMs(this.pullOutPanelRef?.current, 300) + 100;


		this.props.setOrigin(this.props.mainCfg.builderOrigin);

		switch (this.props.mainCfg.builderMode) {
			case TargetType.TRIGGER:
				this.props.setTargetType(TargetType.TRIGGER);
				this.props.setAppState(AppState.TARGET_SELECTION);

				break;
			case TargetType.MOBILE_MENU:
				this.props.setTargetType(TargetType.MOBILE_MENU);
				this.props.setCancelButtonAltPos(true);
				this.props.setAppState(AppState.TARGET_SELECTION);
				document.documentElement.classList.add('dpit-mm');
				break;
			default:
				this.initTinyMce();
				this.props.setTargetType(TargetType.STEP);
				if (this.props.core && this.props.mainCfg.mobileAltStepMode) {
					this.props.core.showIntroLayersDisabled = true;
					this.props.setMobileAltStepMode(this.props.mainCfg.mobileAltStepMode);
					//this.props.core.setOption('disableDelayedAfterCheckPosition', true);
					if (this.props.secondLayerIntroModule.mobileMenu) this.props.secondLayerIntroModule.mobileMenu.forceResponsiveMode = this.props.mainCfg.mobileAltStepMode;
					this.setTargetSelectionModeAfterStep = true;
					localStorage.setItem('dp_intro_tours.mobile_alt_step_mode', this.props.mainCfg.mobileAltStepMode);
					localStorage.setItem('dp_intro_tours.mobile_alt_selector', '');
				}
		}

		if (this.props.isPRO) {
			if (this.props.mainCfg.totalSavedChanges) {
				this.props.setTotalSavedChanges(this.props.mainCfg.totalSavedChanges);
			}
			if (this.props.mainCfg.builderMode === TargetType.STEP && this.dpWpLink) this.dpWpLink.open(null, null, true);
			this.props.secondLayerIntroModule.setCallback('onBeforeRedirect', this.onBeforeRedirect);
		}

		window.addEventListener('beforeunload', (event) => {
			if (this.props.isChange && !this.changesCancelConfirmed) {
				event.preventDefault();
				event.returnValue = '';
			}
		});

	}

	componentDidUpdate(prevProps) {
		// On switch target selecting mode
		if (this.props.core) {
			if (this.props.targetType === TargetType.STEP) {
				if (this.isStateSwitchedOn(AppState.TARGET_SELECTION, prevProps)) {
					this.props.core.showIntroLayersDisabled = true;
					this.lastStepElement = this.props.stepItem.element;
					this.props.setControlsPosition(Position.BOTTOM);
					// hide core elements for target selection
					this.props.core.pauseTour();
					if (this.props.targetType === TargetType.MOBILE_MENU || this.props.targetType === TargetType.STEP && this.props.mobileAltStepMode === RESPONSIVE_MODE.mobileMenu) {
						this.lastCancelButtonAltPos = this.props.cancelButtonAltPos;
						this.props.setCancelButtonAltPos(true);
					}
					else {
						this.lastCancelButtonAltPos = undefined;
					}
				}
				else if (this.isStateSwitchedOff(AppState.TARGET_SELECTION, prevProps)
					&& this.props.appState !== AppState.PAUSE_TARGET_SEL_1_CLICK
					&& this.props.appState !== AppState.PAUSE) {
					this.props.core.showIntroLayersDisabled = false;
					this.props.core.restoreTour();
					if (this.lastCancelButtonAltPos !== undefined) {
						this.props.setCancelButtonAltPos(this.lastCancelButtonAltPos);
						this.lastCancelButtonAltPos = undefined;
					}
				}

			}

			// Pause mode
			if (this.isStateSwitchedOn(AppState.PAUSE, prevProps)) {
				if (this.props.targetType !== TargetType.STEP || this.props.stepCount > 0) this.props.core.pauseTour();
			}
			else if (this.isStateSwitchedOff(AppState.PAUSE, prevProps)) {
				if (this.props.targetType !== TargetType.STEP || this.props.stepCount > 0) this.props.core.restoreTour();
			}

			// Panel edit
			if (this.isStateSwitchedOn(AppState.PANEL_EDIT, prevProps)) {
				this.props.core.disableSkipStepByMobileSize = true;
				this.props.core.disableUserInteraction(() => { alert(i18n.ui_disabled_in_edit_mode); });
				this.props.core.disableStepSkippingWhenNotFoundRefEl();
				this.refreshAfterPullOutPanelChanged();
				this.props.core.setAsEditMode(true);
			} else if (this.isStateSwitchedOff(AppState.PANEL_EDIT, prevProps)) {
				this.props.core.setAsEditMode(false);
				this.refreshAfterPullOutPanelChanged();
			}

			if (this.isStateSwitchedOn(AppState.VIEW, prevProps)) {
				this.props.core.disableSkipStepByMobileSize = false;
				this.props.core.enableUserInteraction();
				this.props.core.enableStepSkippingWhenNotFoundRefEl();


			}
		}
		// Pause 1 click in target selection
		if (this.isStateSwitchedOn(AppState.PAUSE_TARGET_SEL_1_CLICK, prevProps)) {
			if (this.props.core) this.props.core.pauseTour();
			$(document).on('mouseup', this.returnToTargetMode);
		}
		else if (this.isStateSwitchedOff(AppState.PAUSE_TARGET_SEL_1_CLICK, prevProps)) {
			$(document).off('mouseup', this.returnToTargetMode);
		}



		// Url redirect modal
		if (this.isStateSwitchedOn(AppState.REDIRECT_MODAL_OPENED, prevProps)) {
			this.beforeOpenModal();
			const currentUrl = this.props.stepItem && this.props.stepItem.url ? absToRelativeUrl(this.props.stepItem.url, this.props.mainCfg.siteUrl) : '';
			if (this.dpWpLink) this.dpWpLink.open(currentUrl, null, false, false, this.props.step, this.props.tourCfg.url_vars_enabled, this.props.secondLayerIntroModule.urlVarsNoSys, this.props.tourCfg.sysUrlVars);
			$('#wp-link-text').val('');
			$('#dp_wp-link-backdrop, #dpit-wp-link-cancel').on('click', this.afterCloseModal);
			$('#dp_wp-link-submit').on('click', this.onUrlRedirectConfirmClick);

		}
		else if (this.isStateSwitchedOff(AppState.REDIRECT_MODAL_OPENED, prevProps)) {
			$('#dp_wp-link-backdrop, #dpit-wp-link-cancel').off('click', this.afterCloseModal);
			if (this.dpWpLink) this.dpWpLink.close(false, true);
		}

		// Url content edit modal
		if (this.isStateSwitchedOn(AppState.TMCE_MODAL_OPENED, prevProps)) {
			this.beforeOpenModal();
			const content = this.props.stepItem ? this.props.stepItem.intro : '';
			if (this.tmce) this.tmce.open(this.props.stepItem, content, this.props.step);
		}
	}


	onBeforeRedirect = (redirectUrl, backward) => {
		const nextStateInit = this.props.appState !== AppState.REDIRECT_MODAL_OPENED && this.props.appState !== AppState.CANCEL
			? this.props.appState
			: AppState.PANEL_EDIT;
		//if (this.props.core) this.props.core.exitCore(true, false, 'redirect', true, true);
		this.props.setAppState(AppState.REDIRECTING);
		this.saveChanges(() => {
			this.props.setAppState(AppState.CANCEL);
			this.props.secondLayerIntroModule.redirect(redirectUrl + buildDpQueryString({
				dp_qpb_total_saved_changes: this.props.totalSavedChanges,
				dp_qpb_init_state: nextStateInit
			}, this.props.mainCfg.queryParamsDefs, '&')/* dp_to_check &dp_qpb_total_saved_changes=${this.props.totalSavedChanges}&dp_qpb_init_state=${nextStateInit}*/, backward);
		});
		return false;
	};

	async refreshAfterPullOutPanelChanged() {
		if (this.props.targetType === TargetType.STEP && !this.props.mainCfg.mobileAltStepMode && this.props.core.isStickyEditPanel()) {
			//if (this.props.core.isDummyMode() || !this.props.core.isFixedPos) {
			await asyncWait(this.pullOutPanelTransitionMs);
			if (!this.props.core.isPaused()) {
				this.props.core.hardRefresh(REFRESH_REASONS.builder, { scrollOnlyWhenNeeded: false }, 'BUILDER PULL OUT PANEL');
			}
			//}
		}
	}

	initTinyMce() {
		this.tmce = new DpTinyMceDialog({ title: i18n.edit_step }, (target, content) => {
			this.afterCloseModal();
			let hidden_meta_new = { ...this.props.stepItem.hidden_meta };
			if (!hidden_meta_new.ext) hidden_meta_new.ext = {};
			hidden_meta_new.ext.build_with_wp_editor = '1';
			this.setCurrentStepChange('hidden_meta', hidden_meta_new);

			this.setCurrentStepChange('intro', content);

		}, () => {
			this.afterCloseModal();
		}, this.props.mainCfg.dpDebugEn);
	}

	onContentEditClick = () => {
		this.props.setAppState(AppState.TMCE_MODAL_OPENED);
	};

	beforeOpenModal = () => {
		this.props.core.pauseTour('dpit-modal-opened');
		$(document.documentElement).addClass('dpit-modal-opened');
	};

	afterCloseModal = (/*stateToSet = AppState.PANEL_EDIT*/) => {
		this.props.core.restoreTour('dpit-modal-opened');
		this.props.setAppState(AppState.PANEL_EDIT);
		this.props.core.hardRefresh(REFRESH_REASONS.builder, {}, 'BUILDER MODAL CLOSE');
	};

	returnToTargetMode = () => {
		//if (this.props.core) this.props.core.restoreTour();
		this.props.setAppState(AppState.TARGET_SELECTION);
	};

	updateCurrentStepData(stepItem) {
		this.props.setStepCount(this.props.core.stepItems.length);
		this.props.setCurrentCoreElement(stepItem);
		if (stepItem) {
			const updateObj = { ...stepItem };
			if (this.props.core.isDummyMode()) updateObj.element = null;
			this.props.setStepData(updateObj);
		}
	}

	isStateSwitchedOn = (stateName, prevProps = null) => {
		if (prevProps) return prevProps.appState !== stateName && this.props.appState === stateName;
		else return this.props.prevAppState !== stateName && this.props.appState === stateName;
	};

	isStateSwitchedOff = (stateName, prevProps = null) => {
		if (prevProps) return prevProps.appState === stateName && this.props.appState !== stateName;
		else return this.props.prevAppState === stateName && this.props.appState !== stateName;
	};

	setStepChange = (stepIdx, propName, value, advParamName = '') => {
		this.props.setStepProp(propName, value);
		this.setStepChanges(stepIdx, { [propName]: value }, null, null, false, advParamName);
	};

	setCurrentStepChange = (propName, value, advParamName = '') => {
		this.setStepChange(this.props.core.stepIdx, propName, value, advParamName);
	};

	setCurrentSelectorAndElement = (selector, newElement = null) => {

		this.props.setStepProp('element', newElement);
		this.setStepChanges(this.props.core.stepIdx, { 'element': selector }, newElement, null, !selector);
	};

	setSkipStep = (skipMobileType, value) => {
		this.props.setStepProp(skipMobileType, value);

		this.setStepChanges(this.props.core.stepIdx, { [skipMobileType]: value }, null, null, false);
	};

	setAltMobileSelector = (selector, mobileAltStepMode) => {
		if (mobileAltStepMode === RESPONSIVE_MODE.mobileMenu) {
			this.props.setStepProp('alt_mobile_selector', selector);
			this.props.setStepProp('is_in_mobile_menu', selector ? '1' : '0');
			this.setStepChanges(this.props.core.stepIdx, { alt_mobile_selector: selector, is_in_mobile_menu: selector ? '1' : '0' }, null, mobileAltStepMode);
		}
		else {
			const key = `alt_${mobileAltStepMode}_selector`;
			this.props.setStepProp(key, selector);
			this.props.setStepProp('0');
			this.setStepChanges(this.props.core.stepIdx, { [key]: selector }, null, mobileAltStepMode);
		}
	};

	_isNotNullOrUndefinedOrSameAsSecond(first, second) {
		return first !== null && first !== undefined && first !== second;
	}

	setCurrentStepChanges = (changeObject, newElement = null) => {
		this.setStepChanges(this.props.core.stepIdx, changeObject, newElement);
	};

	setStepChanges = (stepIdx, changeObject, newElement = null, mobileAltStepMode = null, removeCurrentElement = false) => {

		let shouldUpdateIntro = false;
		const stepItem = this.props.stepItem;
		if (newElement) {
			if (newElement != stepItem.element) {
				stepItem.selector = changeObject.element;
				shouldUpdateIntro = true;
				this.props.addChange(TargetType.STEP, stepIdx, changeObject);
			}
		}
		else if (removeCurrentElement) {
			stepItem.selector = changeObject.element;
			stepItem.element = null;
			shouldUpdateIntro = true;
			this.props.setStepProp('selector', null);
			this.props.addChange(TargetType.STEP, stepIdx, changeObject);
		}
		else if (mobileAltStepMode) {
			if (mobileAltStepMode === RESPONSIVE_MODE.mobileMenu) {
				stepItem['alt_mobile_selector'] = changeObject.alt_mobile_selector;
				stepItem.is_in_mobile_menu = changeObject.alt_mobile_selector ? '1' : '0';
			}
			else {
				stepItem[`alt_${mobileAltStepMode}_selector`] = changeObject[`alt_${mobileAltStepMode}_selector`];
				stepItem.is_in_mobile_menu = '0';
			}
			shouldUpdateIntro = true;
			this.props.addChange(TargetType.STEP, stepIdx, changeObject);
		}
		else {
			this.props.addChange(TargetType.STEP, stepIdx, changeObject);
		}
		if (this._isNotNullOrUndefinedOrSameAsSecond(changeObject.intro, stepItem.intro)) {

			stepItem.intro = changeObject.intro;
			stepItem.intro_proc = changeObject.intro;
			shouldUpdateIntro = true; // it is refreshed after 
		}
		if (this._isNotNullOrUndefinedOrSameAsSecond(changeObject.skip_on_big_screen, stepItem.skip_on_big_screen)) {
			stepItem.skip_on_big_screen = changeObject.skip_on_big_screen;
		}
		if (this._isNotNullOrUndefinedOrSameAsSecond(changeObject.skip_on_mobile, stepItem.skip_on_mobile)) {
			stepItem.skip_on_mobile = changeObject.skip_on_mobile;
		}
		if (this._isNotNullOrUndefinedOrSameAsSecond(changeObject.position, stepItem.position)) {
			stepItem.position = changeObject.position;
			shouldUpdateIntro = true;
		}

		if (this._isNotNullOrUndefinedOrSameAsSecond(changeObject.highlight, stepItem.highlight)) {
			stepItem.highlight = changeObject.highlight;
			shouldUpdateIntro = true;
		}

		if (this._isNotNullOrUndefinedOrSameAsSecond(changeObject.enable_interaction, stepItem.enable_interaction)) {

			stepItem.enable_interaction = changeObject.enable_interaction;
			shouldUpdateIntro = true;
		}

		if (shouldUpdateIntro) {

			this.props.core.showStep();
		}
	};

	redirectToOrigin = async (origin = null, confirmNotActive = true, wasTourDeleted = false, disableAnimation = false) => {
		this.props.setAppState(AppState.CANCEL);
		if (this.props.mainCfg.inNewWindow) {
			window.close();
			return;
		}
		if (this.props.core) this.props.core.exitCore(true, false, 'redirect', true, disableAnimation);
		let originVal = origin ? origin : this.props.origin;
		if (origin === Origin.ADMIN && this.props.origin === Origin.SETTINGS) {
			originVal = Origin.SETTINGS;
		}

		let redirectUrl = '';

		const mappedParams = {
			dp_qpb_origin_el_id: this.props.mainCfg.originHashId,
			dp_qpb_canceled: this.props.totalSavedChanges > 0 ? null : 1
		};
		//http://192.168.1.100:3000/wp-admin/edit.php?post_type=dp_intro_tours
		switch (originVal) {
			case Origin.FRONTEND: {
				redirectUrl = window.location.pathname;
				if (this.props.secondLayerIntroModule.setCloseReloadCookieOnExit) this.props.secondLayerIntroModule.setCloseReloadCookieOnExit(true);
				break;
			}
			case Origin.ADMIN: {
				if (wasTourDeleted) {
					redirectUrl = urlJoin(this.props.mainCfg.siteUrl, 'wp-admin/edit.php?post_type=dp_intro_tours');
				} else {
					redirectUrl = urlJoin(this.props.mainCfg.siteUrl, 'wp-admin/post.php' + buildDpQueryString(mappedParams, this.props.mainCfg.queryParamsDefs, '?', { post: this.props.tourCfg.tourId, action: 'edit' }));
				}
				break;
			}
			case Origin.SETTINGS: redirectUrl = urlJoin(this.props.mainCfg.siteUrl, this.props.mainCfg.settingsPath + buildDpQueryString(mappedParams, this.props.mainCfg.queryParamsDefs, '&', { action: 'edit' })); break;
		}
		await asyncWait(this.props.targetType === TargetType.STEP ? 700 : 0); //tooltip fade out
		if (this.isPromoPopupReady()) {
			this.props.setAppState(AppState.PROMO_MODAL_OPENED);
			this.redirectToOriginURL = redirectUrl;
		}
		else {
			if (originVal === Origin.FRONTEND && this.props.targetType === TargetType.STEP && !this.props.tourCfg.intro_enabled) {

				if (confirmNotActive && confirm(i18n.tour_not_active_prompt)) {
					//hashId = 'acf-field_5e4c8efdab990'; // activate switch
					// cspell:ignore acf-field_5e4c8efdab990
					redirectUrl = urlJoin(this.props.mainCfg.siteUrl, 'wp-admin/post.php' + buildDpQueryString({ dp_qpb_origin_el_id: 'acf-field_5e4c8efdab990' }, this.props.mainCfg.queryParamsDefs, '?', { post: this.props.tourCfg.tourId, action: 'edit' })/*`?post=${this.props.tourCfg.tourId}&action=edit&dp_qpb_origin_el_id=${hashId}`*/);
				}

			}
			window.location.href = redirectUrl;
		}
	};


	exitNoUnsavedChange = (origin = null) => {
		if (this.props.tourCfg && this.props.tourCfg.createNew && this.props.totalSavedChanges <= 0) {
			if (confirm(i18n.new_unsaved_tour_prompt)) {

				this.props.updateHint({
					active: true,
					type: 'info',
					pulse: true,
					dismissible: false,
					title: i18n.tour_removing_notice
				});
				this.props.setAppState(AppState.CANCEL);
				if (this.props.core) {
					this.props.core.exitCore(true, false, 'redirect', true);
				}
				this.props.deleteTourPost(this.props.tourCfg.tourId, true,
					() => this.redirectToOrigin(origin, false, true, true)
				);
			}
		}
		else {
			this.redirectToOrigin(origin);
		}
	};

	exit = (origin = null) => {
		if (this.props.isChange) {
			if (confirm(i18n.unsaved_changes_prompt)) {
				this.changesCancelConfirmed = true;
				this.exitNoUnsavedChange(origin);
			}
		}
		else {
			this.exitNoUnsavedChange(origin);

		}
	};


	onRemoveButtonClick = async () => {
		if (confirm(i18n.remove_step_q)) {
			if (this.props.appState === AppState.PANEL_EDIT) {
				this.disableEditButton = true;
				this.disableCloseButton = true;
				this.props.setAppState(AppState.VIEW);
				await asyncWait(150); // wait for pullout panel close
				this.removeStepAt(this.props.core.stepIdx);
			}
			else {
				this.removeStepAt(this.props.core.stepIdx);
			}
		}
	};

	async removeStepAt(stepIdx) {
		const oldStepCnt = this.props.core.stepItems.length;
		const isAtEnd = stepIdx === this.props.core.stepItems.length - 1;
		this.props.core.removeStepAt(stepIdx);
		this.props.onStepRemovedAt(stepIdx, oldStepCnt);
		if (this.props.core.stepItems.length > 0) {
			if (!this.isStepAddingOrRemovingInProcess) {
				this.isStepAddingOrRemovingInProcess = true;
				this.props.closeHint();
				await asyncWait(150);
				if (isAtEnd) {
					this.props.core.goToPrevStep();
				}
				else {
					this.props.core.goToStep(stepIdx, true);
				}
				//await asyncWait(150);
				if (this.props.appState !== AppState.REDIRECTING && !isNaN(this.props.core.stepIdx)) {
					this.props.setAppState(AppState.PANEL_EDIT);
				} else {
					this.props.core.hideIntroLayers();
				}
				this.disableCloseButton = false;
				this.disableEditButton = false;
				this.isStepAddingOrRemovingInProcess = false;
			}
		}
		else {
			this.disableEditButton = false;
			this.disableCloseButton = false;
			this.props.setAppState(AppState.VIEW);
			this.props.core.pauseTour('', true);
			this.props.secondLayerIntroModule;
			await asyncWait(150);
			this.updateCurrentStepData({});
			this.closeMobileMenu();
		}
	}


	addNewStepAfterButtonClick = async (isFirstStep = false) => {
		if (!this.isStepAddingOrRemovingInProcess) {
			this.isStepAddingOrRemovingInProcess = true;
			const idx = isFirstStep ? 0 : this.props.core.stepIdx + 1;
			if (this.props.appState === AppState.PANEL_EDIT) {
				this.disableEditButton = true;
				this.disableCloseButton = true;
				this.props.setAppState(AppState.VIEW);
				await asyncWait(150);
				this.addNewStepAt(idx, isFirstStep);
			}
			else {
				this.addNewStepAt(idx, isFirstStep);
			}
		}
	};

	addNewStepAt = async (stepIdx, addingFirstStep) => {
		const newLength = this.props.core.stepItems.length + 1;
		const { stepItemBase, stepItem } = this.props.core.addNewStepAt(stepIdx, true);
		this.props.onNewStepAddedAt(stepIdx, newLength);
		this.props.addChange(TargetType.STEP, stepIdx, stepItemBase);

		if (addingFirstStep) {
			if (this.props.core.isPaused()) {
				this.updateCurrentStepData(stepItem);
				this.props.core.restoreTour('', REFRESH_REASONS.restore, stepItem);
			} else {
				this.props.core.startByFirstStepItem(stepItem);
			}
		}
		else {
			//this.props.core.actualizeCurrentStep(stepItem);
			this.props.core.goToStep(stepItem.idx);
		}
		await asyncWait(150);
		this.disableEditButton = false;
		this.disableCloseButton = false;
		this.props.setAppState(AppState.PANEL_EDIT);
		this.isStepAddingOrRemovingInProcess = false;
	};

	onPanelCloseClick = () => {
		this.props.setAppState(AppState.VIEW);
	};

	cancelButtonClick = (origin = null) => {
		switch (this.props.appState) {
			case AppState.TARGET_SELECTION:
				if (this.props.targetType === TargetType.MOBILE_MENU) {
					if (this.props.isChange) {
						//this.props.setMobileMenuOpenerSelected(false);
						this.props.setAppState(AppState.VIEW);
					}
					else this.exit();
					return;
				}

				if (this.props.mobileAltStepMode) {
					this.props.setMobileAltStepMode(null);
				}
				this.props.setAppState(this.props.targetType === TargetType.STEP ? AppState.PANEL_EDIT : AppState.VIEW); break;
			default:
				if (origin) this.exit(origin); // open multi container on touch ... not close
				break;
		}
	};

	onHideControlsClick = () => {
		if (this.props.appState === AppState.PAUSE) this.props.setAppState(this.props.prevAppState);
		else this.props.setAppState(AppState.PAUSE);
	};

	hintCtaClick = () => {
		if (this.props.targetType === TargetType.STEP && this.props.mobileAltStepMode === RESPONSIVE_MODE.mobileMenu) {
			// force open mobile menu
			if (this.props.secondLayerIntroModule.forceOpenMobileMenu) this.props.secondLayerIntroModule.forceOpenMobileMenu();
		}
	};

	updateMobileMenu(stepItem, forceResponsiveMode = null) {
		if (this.props.secondLayerIntroModule.updateMobileMenu) this.props.secondLayerIntroModule.updateMobileMenu(stepItem, forceResponsiveMode);
	}

	closeMobileMenu() {
		if (this.props.secondLayerIntroModule.closeMobileMenu) this.props.secondLayerIntroModule.closeMobileMenu();
	}


	onTargetSelectionStarted = (mobileAltStepMode = null) => {

		this.props.setMobileAltStepMode(mobileAltStepMode);
		if (mobileAltStepMode) {
			if (!this.props.mainCfg.mobile_menu_opener && mobileAltStepMode === RESPONSIVE_MODE.mobileMenu) {
				// Mobile opener / closer is not yet set
				const question = this.props.isChange ? i18n.would_save_and_go_for_it : i18n.would_go_for_it;
				if (confirm(i18n.set_mob_menu_first + ' ' + question)) {
					this.props.setAppState(AppState.VIEW);
					this.saveChanges(() => {
						this.mobileMenuOptionVisualBuilderLoader.openBuilder();
					});
				}
				else {
					this.props.setMobileAltStepMode(null);
				}
			}
			else {
				//this.props.core.setOption('disableDelayedAfterCheckPosition', true);
				if (window.innerWidth <= (this.props.mainCfg.mobile_break_points?.mobile || 600)) {

					this.updateMobileMenu(this.props.stepItem, mobileAltStepMode);
					this.props.setAppState(AppState.TARGET_SELECTION);
				}
				else if (!this.mobilePopup || this.mobilePopup.closed) {
					// Open in new window (mobile size)
					let query = this.props.secondLayerIntroModule.getRedirectQuery(this.props.core.stepIdx, false, 0, true, {
						dp_qpb_in_new_window: 1,
						dp_qpb_mobile_alt_step_mode: mobileAltStepMode
					});
					// dp_to_check	+ `&dp_qpb_in_new_window=1&dp_qpb_mobile_alt_step_mode=${mobileAltStepMode}`;
					const currentUrl = this.props.secondLayerIntroModule.preprocessStepUrl(this.props.stepItem.url, this.props.stepItem.idx);
					const href = urlJoin(currentUrl, query);
					this.props.setAppState(AppState.CANCEL);

					// TODO Target selector in new window ... new app
					this.setStepChanges(this.props.core.stepIdx, {
						is_in_mobile_menu: mobileAltStepMode === RESPONSIVE_MODE.mobileMenu ? '1' : '0',
						alt_mobile_selector: '',
					}, null, mobileAltStepMode);

					this.onResetMobileTargetClick(mobileAltStepMode);
					this.mobileViewPopup.addOverlay();
					this.saveChanges(() => {
						this.mobilePopup = this.mobileViewPopup.popupCenter(href, 'DP Mobile menu support', 480, window.outerHeight * 0.9);
					});
				}
			}
		}
		else {
			this.updateMobileMenu(this.props.stepItem, RESPONSIVE_MODE.desktop);
			this.props.setAppState(AppState.TARGET_SELECTION);
			if (this.props.targetType === TargetType.TRIGGER) {
				//this.props.core.hideOverlay();
			}
		}

	};

	onTargetSelected = async (selector, selectedEl, isError) => {
		if (isError) {
			this.props.setAppState(AppState.VIEW);
			this.props.updateHint({
				active: true,
				type: 'error',
				pulse: true,
				dismissible: true,
				title: i18n.target_selector_err_title,
				desc: i18n.target_selector_err_desc
			});
		}
		else {
			switch (this.props.targetType) {
				case TargetType.STEP: {

					if (this.props.mobileAltStepMode) {
						//this.props.core.setOption('disableDelayedAfterCheckPosition', false);
						if (this.props.mainCfg.mobileAltStepMode) {
							localStorage.setItem('dp_intro_tours.mobile_alt_step_mode', this.props.mainCfg.mobileAltStepMode);
							localStorage.setItem('dp_intro_tours.mobile_alt_selector', selector);
							this.redirectToOrigin();
							return;
						}
						else {
							this.setAltMobileSelector(selector, this.props.mobileAltStepMode);
						}
					}
					else {
						this.setCurrentSelectorAndElement(selector, selectedEl);
					}
					this.props.core.actualizeUserInteraction();
					this.props.setAppState(AppState.PANEL_EDIT);
					this.updateMobileMenu(this.props.stepItem, this.props.mobileAltStepMode);
					this.props.setMobileAltStepMode(null);

				} break;
				case TargetType.TRIGGER: {
					this.props.tourCfg.triggers[this.props.mainCfg.triggerId].selector = selector;
					this.props.addChange(TargetType.TRIGGER, this.props.mainCfg.triggerId, selector);
					this.props.setAppState(AppState.VIEW);
				} break;
				case TargetType.MOBILE_MENU: {
					if (this.props.mobileMenuOpenerSelected) {
						// set closer
						this.props.mainCfg.mobileMenu.closer = selector;
						this.props.setMobileMenuOpenerSelected(false);
						this.props.addChange('mobileMenu', 'closer', selector);
						this.props.setAppState(AppState.VIEW);
					}
					else {
						this.props.mainCfg.mobileMenu.opener = selector;
						this.props.setMobileMenuOpenerSelected(true);
						this.props.addChange('mobileMenu', 'opener', selector);
						this.props.setAppState(AppState.INIT);
						this.props.closeHint();
						await asyncWait(300);
						this.props.setAppState(AppState.TARGET_SELECTION);
					}
				} break;
			}
		}
	};

	onResetMobileTargetClick = (mobileAltStepMode) => {
		this.props.stepItem.alt_mobile_selector = '';
		this.props.stepItem.element = null;
		this.props.stepItem.is_in_mobile_menu = '0';
		this.updateMobileMenu(this.props.stepItem);
		this.setAltMobileSelector('', mobileAltStepMode);
	};

	onResetTargetClick = () => {
		this.setCurrentSelectorAndElement('');
	};

	onSkipChange = (skipMobileType, value) => {
		this.setSkipStep(skipMobileType, value);
	};


	onMobileViewPopupExit = () => {
		const mobile_alt_step_mode = localStorage.getItem('dp_intro_tours.mobile_alt_step_mode');
		const mobile_alt_selector = localStorage.getItem('dp_intro_tours.mobile_alt_selector');

		if (mobile_alt_step_mode && mobile_alt_selector) {
			this.setAltMobileSelector(mobile_alt_selector, mobile_alt_step_mode);
			localStorage.setItem('dp_intro_tours.mobile_alt_step_mode', '');
			localStorage.setItem('dp_intro_tours.mobile_alt_selector', '');
		}

		this.props.setAppState(AppState.PANEL_EDIT);
	};

	onPreviousStepButtonClick = () => {
		this.props.core.goToPrevStep();
	};

	onNextStepButtonClick = () => {
		this.props.core.goToNextStep();
	};

	onSaveChangesButtonClick = () => {
		this.saveChanges(() => {
			if (this.props.targetType === TargetType.STEP) {
				for (let i = 0; i < this.props.core.stepItems.length; i++) {
					this.props.core.stepItems[i].isNewStep = false;
				}
				this.props.setStepProp('isNewStep', false);
			}
			else if (this.props.targetType === TargetType.MOBILE_MENU) {
				if (this.props.mainCfg.inNewWindow) this.exit();
				else {
					this.props.setAppState(AppState.CANCEL);
					if (!this.mobileMenuOptionVisualBuilderLoader.tryRedirectToOrigin()) {
						this.exit();
					}
				}
			}
			else if (this.props.targetType === TargetType.TRIGGER) {
				this.exit();
			}
		});
	};

	disableApp = () => {
		if (this.props.core) {
			this.props.core.disablePointerEvents();
			this.props.core.disableKeyboardNavig();
		}
	};

	enableApp = () => {
		if (this.props.core) {
			this.props.core.enablePointerEvents();
			this.props.core.enableKeyboardNavig();
		}
	};

	saveChanges = (onSuccess, onError, successWhenNoChange = true) => {
		if (this.props.isChange) {
			const stepChangesEncoded = {};
			Object.keys(this.props.stepChanges).forEach(stepIdx => {
				stepChangesEncoded[stepIdx] = {};
				Object.keys(this.props.stepChanges[stepIdx]).forEach(propName => {
					stepChangesEncoded[stepIdx][propName] = encodeStepParamAdvancedVal(this.props.stepChanges[stepIdx][propName], propName, this.props.mainCfg.stepDefinitions);
				});
			});
			this.disableApp();
			this.props.saveChanges(
				this.props.tourCfg ? this.props.tourCfg.tourId : null,
				stepChangesEncoded,
				this.props.triggerChanges,
				this.props.mobileMenuChanges,
				this.props.urlVarExamplesChanges,
				this.props.stepAddedRemovedHist,
				() => { this.enableApp(); if (onSuccess) onSuccess(); },
				() => { this.enableApp(); if (onError) onError(); }
			);
		}
		else if (successWhenNoChange && onSuccess) {
			onSuccess();
		}
	};

	onUrlRedirectClick = () => {
		if (this.props.secondLayerIntroModule && this.props.isPRO) {
			this.props.setAppState(AppState.REDIRECT_MODAL_OPENED);
		}
		else if (this.props.mainCfg.proFeaturesLink) {
			if (confirm(i18n.multi_page_only_pro_prompt + ' ' + i18n.would_you_like_to_check_it)) {
				window.open(this.props.mainCfg.proFeaturesLink, '_blank');
			}
		}
	};

	onUrlRedirectConfirmClick = async () => {

		if (this.dpWpLink) {
			let linkAttrs = this.dpWpLink.getAttrs();
			const containsCurrentUrlVariables = isVariableUrl(linkAttrs.href) && this.props.tourCfg.url_vars_enabled;
			let isValidVariableUrl = false;
			let err = {};
			if (containsCurrentUrlVariables) {
				if (this.props.core.stepIdx === 0) {
					isValidVariableUrl = linkAttrs.urlVarExamples && Object.values(linkAttrs.urlVarExamples).every(val => val.length > 0);
					if (isValidVariableUrl) {
						const newUrlVarExamplesStr = simpleObjectToStr(linkAttrs.urlVarExamples, '\n');
						if (newUrlVarExamplesStr !== simpleObjectToStr(this.props.secondLayerIntroModule.urlVars, '\n')) {
							const urlVarsNoSys = {};
							Object.keys(linkAttrs.urlVarExamples).forEach(urlVarKey => {
								if (!urlVarKey.startsWith('$')) {
									urlVarsNoSys[urlVarKey] = linkAttrs.urlVarExamples[urlVarKey];
								}
							});

							this.props.secondLayerIntroModule.urlVarsNoSys = urlVarsNoSys;
							this.props.secondLayerIntroModule.urlVars = linkAttrs.urlVarExamples;
							this.props.addChange(TargetType.URL_VAR_EXAMPLES, this.props.core.stepIdx, newUrlVarExamplesStr);
						}
					} else {
						err = {
							title: i18n.url_examples_not_set_title,
							desc: sprintf(i18n.url_examples_not_set_desc, linkAttrs.href.replace(/&/g, '&amp;'))
						};
					}
				}
				else {
					const varIds = this.dpWpLink.getUrlVarIdsFromUrl(linkAttrs.href, false);
					if (varIds && varIds.length && this.props.secondLayerIntroModule.urlVars) {
						isValidVariableUrl = true;
						for (const varId of varIds) {
							if (!([varId] in this.props.secondLayerIntroModule.urlVars) || this.props.secondLayerIntroModule.urlVars[varId] === '') {
								isValidVariableUrl = false;
								err = {
									title: i18n.unknown_url_var_title,
									desc: sprintf(i18n.unknown_url_var_desc, linkAttrs.href.replace(/&/g, '&amp;'), varId)
								};
								break;
							}
						}

					}
				}
			}

			if (!containsCurrentUrlVariables || isValidVariableUrl) {

				const isKeepVarUrl = this.props.secondLayerIntroModule.isKeepVarUrl(linkAttrs.href);

				const absUrlRaw = sanitizePossibleRelativeUrl(linkAttrs.href, this.props.mainCfg.siteUrl);
				let href = this.props.secondLayerIntroModule.preprocessStepUrl(linkAttrs.href, this.props.stepItem.idx);
				let absUrl = sanitizePossibleRelativeUrl(href, this.props.mainCfg.siteUrl);
				let isAtSameDomain = isUrlAtOurSite(absUrl, this.props.mainCfg.siteUrl);

				if (isAtSameDomain || this.props.tourCfg.properties.allow_redirect_to_extraneous_url) {
					$('#dp_wp-link-submit').off('click', this.onUrlRedirectConfirmClick);

					if (href.length && this.props.secondLayerIntroModule.shouldReloadBetweenSteps(absUrl, removeURLParameters(window.location.href, this.props.mainCfg.queryParamsDefs)) /*!this.props.secondLayerIntroModule.isUrlSame(absUrl, window.location.href, true)*/) {
						// check if exists
						this.dpWpLink.activateSubmitButtonSpinner(true);

						//this.dpWpLink.close(null, true);
						//this.props.core.showOverlay();
						this.props.addChange(TargetType.STEP, this.props.core.stepIdx, { url: containsCurrentUrlVariables || isKeepVarUrl ? linkAttrs.href : href });
						await asyncWait(150);
						this.props.stepItem.url = isKeepVarUrl ? linkAttrs.href : (containsCurrentUrlVariables ? absUrlRaw : absUrl);
						this.saveChanges(() => {
							//this.dpWpLink.close(null, true);
							if (!isAtSameDomain) {
								this.afterCloseModal(AppState.VIEW);
								this.props.updateHint({
									active: true,
									type: 'info',
									pulse: true,
									dismissible: true,
									title: i18n.redirecting_ext_q,
									desc: i18n.ext_url_current_just_set + ' ' + i18n.ext_url_not_redirect
								});

							}
							else {
								this.props.secondLayerIntroModule.routing(this.props.stepItem, this.props.secondLayerIntroModule.isInitializedBackward());
							}
						}, () => this.afterCloseModal());
					}
					else {
						let updateUrlInHist = false;
						if (isKeepVarUrl) {
							this.props.addChange(TargetType.STEP, this.props.core.stepIdx, { url: linkAttrs.href });
							this.props.stepItem.url = linkAttrs.href;
						} else if (isValidVariableUrl) {
							this.props.addChange(TargetType.STEP, this.props.core.stepIdx, { url: linkAttrs.href });
							this.props.stepItem.url = absUrlRaw;
							updateUrlInHist = true;
						}
						else if (!this.props.secondLayerIntroModule.isUrlSame(absUrl, this.props.secondLayerIntroModule.preprocessStepUrl(
							this.props.stepItem.url,
							this.props.stepItem.idx
						), true)) {
							this.props.addChange(TargetType.STEP, this.props.core.stepIdx, { url: href });
							this.props.stepItem.url = absUrl;
							updateUrlInHist = true;
						}

						if (updateUrlInHist) {
							const newUrl = urlJoin(absUrl, this.props.secondLayerIntroModule.getRedirectQuery(this.props.core.stepIdx, false, 0, false));
							window.history.pushState({}, document.title, newUrl);
						}

						this.afterCloseModal();
					}
				} else {
					this.props.updateHint({
						active: true,
						type: 'error',
						pulse: true,
						dismissible: true,
						title: i18n.wrong_url_title,
						desc: sprintf(i18n.wrong_url_desc, href, this.props.mainCfg.siteUrl)
					});
				}
			}
			else {
				this.props.updateHint({
					active: true,
					type: 'error',
					pulse: true,
					dismissible: true,
					...err
				});
			}
		}
	};


	closePromoPopup = async () => {
		const prevState = this.props.prevAppState;
		this.props.setAppState(prevState);
		if (prevState === AppState.CANCEL) {
			await asyncWait(300);
			this.props.core.startFullScreenAnimation(true);
			window.location.href = this.redirectToOriginURL;
		}
	};

	onCloseClickPromoPopup = () => {
		this.props.sendAskForRatingFeedbackToDP('closed');
		this.closePromoPopup();
	};

	promoPopupYesClick = () => {
		this.setAskForRatingFlag(120);
		this.props.sendAskForRatingFeedbackToDP('ok');
		this.closePromoPopup();
		return true;
	};

	promoPopupNoClick = () => {
		this.setAskForRatingFlag();
		this.props.sendAskForRatingFeedbackToDP('no-good');
		this.closePromoPopup();
	};

	isPromoPopupReady = () => {
		if (this.props.isPRO) return false;
		if (this.props.mainCfg.promoDebug === '1') return true;
		return this.props.mainCfg.asrEnabled
			&& this.props.totalSavedChanges >= 10
			&& this.props.mainCfg.isRightTime4ask4Rating
			&& this.props.mainCfg.ask4ratingText
			&& this.props.targetType === TargetType.STEP;

	};

	setAskForRatingFlag = (expiresDays = 90) => {
		if (this.props.mainCfg.a4rCookieName) Cookies.set(this.props.mainCfg.a4rCookieName, '1', { expires: expiresDays });
	};

	getPullOutPanelTitle() {
		let pullOutPanelTitle = '';
		switch (this.props.targetType) {
			case TargetType.STEP: {
				if (!this.props.isNewStep) pullOutPanelTitle = sprintf(i18n.edit_step, getNthStr(this.props.step));
				else pullOutPanelTitle = sprintf(i18n.new_step, this.props.step);
			} break;
		}
		return pullOutPanelTitle;
	}

	getTargetSelectorConfig() {
		const config = {
			initSelector: null,
			mode: TargetSelectorMode.MOST_PARENT,
			selectorBlackList: [
				'.dpit-controls__button',
				CLASSES_CORE.disableInteraction,
				'.dpit-popup-hint',
				'.dp-target-sel-bl'
			]
		};
		switch (this.props.targetType) {
			case TargetType.STEP: {
				if (this.props.stepItem && !this.props.core.isDummyMode()) {
					switch (this.props.mobileAltStepMode) {

						case RESPONSIVE_MODE.mobile:
							if (this.props.stepItem.is_in_mobile_menu === '0') {
								config.initSelector = this.props.stepItem.alt_mobile_selector;
							}
							break;
						case RESPONSIVE_MODE.mobileMenu:
							if (this.props.stepItem.is_in_mobile_menu === '1') {
								config.initSelector = this.props.stepItem.alt_mobile_selector;
							}
							break;
						default: config.initSelector = this.props.stepItem.selector; break;
					}
				}
				if (this.props.mobileAltStepMode === RESPONSIVE_MODE.mobileMenu) {
					config.selectorBlackList = [
						...config.selectorBlackList,
						this.props.mainCfg.mobile_menu_closer,
						this.props.mainCfg.mobile_menu_opener
					];
				}
			} break;
			case TargetType.TRIGGER: {
				config.initSelector = this.props.tourCfg.triggers[this.props.mainCfg.triggerId].selector;
				config.mode = TargetSelectorMode.ORIGINAL;
			} break;
			case TargetType.MOBILE_MENU: {
				config.initSelector = this.props.mobileMenuOpenerSelected ? this.props.mainCfg.mobileMenu.closer : this.props.mainCfg.mobileMenu.opener;
				config.mode = TargetSelectorMode.ORIGINAL;
			} break;

		}
		return config;
	}

	render() {
		const promoPopup = this.isPromoPopupReady()
			? <Popup
				classBEMRoot="dpit-popup-promo"
				closeButtonClass="dpit-button-close-popup"
				onCloseClick={this.onCloseClickPromoPopup}
				closeButtonTitle={i18n.close_hint}
				active={this.props.appState === AppState.PROMO_MODAL_OPENED}
				type='promo'
				dismissible={true}
				title={i18n.enjoying_builder_q}
				desc={[
					this.props.mainCfg.ask4ratingText
				]}
				imageSrc={FiveStarImage}
				imageAlt={i18n.five_stars}
			>   <div className="dpit-popup-promo__buttons">
					<Button
						classBEMRoot='dpit-popup-promo__buttons__btn dpit-popup-promo__buttons__btn--yes'
						text={i18n.yes_tou_deserve_it + ' :)'}
						onClick={this.promoPopupYesClick}
						active={true}
						href={this.props.mainCfg.freeRatingLink}
						target='_blank'
					/>
					<Button
						classBEMRoot='dpit-popup-promo__buttons__btn dpit-popup-promo__buttons__btn--no'
						text={i18n.not_good_enough}
						onClick={this.promoPopupNoClick}
						active={true}
					/>
				</div>
			</Popup>
			: null;

		const panelContent = (this.props.targetType === TargetType.STEP)
			? <StepEdit
				core={this.props.core}
				isPRO={this.props.isPRO}
				dpDebugEn={this.props.mainCfg.dpDebugEn}
				mobile_menu_opener={this.props.mainCfg.mobile_menu_opener}
				positionConfig={this.props.mainCfg.tour_step_editor.select_position.select}
				highlightConfig={this.props.mainCfg.tour_step_editor.select_highlight.select}
				setCurrentStepChange={this.setCurrentStepChange}
				onTargetSelectionStarted={this.onTargetSelectionStarted}
				navigLabeling={this.props.tourCfg ? this.props.tourCfg.labeling : {}}
				onPreviousStepButtonClick={this.onPreviousStepButtonClick}
				onNextStepButtonClick={this.onNextStepButtonClick}
				onRemoveButtonClick={this.onRemoveButtonClick}
				onUrlRedirectClick={this.onUrlRedirectClick}
				onContentEditClick={this.onContentEditClick}
				proFeaturesLink={this.props.mainCfg.proFeaturesLink}
				addNewStepAfterFce={() => this.addNewStepAfterButtonClick(false)}
				onResetMobileTargetClick={this.onResetMobileTargetClick}
				onResetTargetClick={this.onResetTargetClick}
				onSkipChange={this.onSkipChange}
				i18n={this.props.mainCfg.i18n}
				stepDefinitions={this.props.mainCfg.stepDefinitions}
			></StepEdit>
			: null;
		const targetSelectorConfig = this.getTargetSelectorConfig();

		return (
			<Fragment>
				<TargetSelector
					classBEMRoot='dp-target-selector'
					className={classNames({
						['dp-target-selector--trigger']: this.props.targetType === TargetType.TRIGGER,
						['dp-target-selector--mobile']: this.props.targetType === TargetType.MOBILE_MENU || (this.props.targetType === TargetType.STEP && this.props.mobileAltStepMode)
					})}
					dpDebugEn={this.props.mainCfg.dpDebugEn}
					hideConfirmed={[AppState.CANCEL, AppState.PAUSE_TARGET_SEL_1_CLICK, AppState.PAUSE].includes(this.props.appState) || this.props.targetType !== TargetType.TRIGGER}
					leaveConfirmedVisible={this.props.targetType === TargetType.TRIGGER && this.props.appState !== AppState.PAUSE_TARGET_SEL_1_CLICK}
					mode={targetSelectorConfig.mode}
					visualizedTargetClass='dp-visualized-target'
					initialTargetSelector={targetSelectorConfig.initSelector}
					active={this.props.appState === AppState.TARGET_SELECTION}
					onTargetSelected={this.onTargetSelected}
					suppressClickEvents={this.props.targetType !== TargetType.MOBILE_MENU}
					selectorBlackList={targetSelectorConfig.selectorBlackList}
					selectorBlackListExit={[
						'.dpit-controls__multi-close'
					]}
					selectorTypes={['ID', 'Class', 'Tag', 'NthChild']}
					container={this.props.secondLayerIntroModule.wrapEl}
				/>
				{promoPopup}
				<PullOutPanel
					classBEMRoot='dp-pull-out-panel'
					active={this.props.appState === AppState.PANEL_EDIT && !isNaN(this.props.step)}
					disabled={this.props.stepChangingInProgress}
					title={this.getPullOutPanelTitle()}
					onCloseClick={this.onPanelCloseClick}
					timeOut={300}
					dropDownActive={(this.props.isTargetDetailOpened && this.props.isPRO) || this.props.isInteractionDetailOpened || this.props.stepChangingInProgress}
					keepTargetCtrl={!this.props.stepChangingInProgress}
					onBackDropClick={() => { this.props.updateTargetDetailOpened(false); this.props.updateInteractionDetailOpened(false); }}
					panelRef={this.pullOutPanelRef}
				>
					{panelContent}
				</PullOutPanel>
				<BuilderControls
					mainCfg={this.props.mainCfg}
					tourCfg={this.props.tourCfg}
					addNewStepAfterFce={() => this.addNewStepAfterButtonClick(true)}
					onSaveChangesButtonClick={this.onSaveChangesButtonClick}
					disableEditButton={this.disableEditButton}
					disableCloseButton={this.disableCloseButton}
					onCancelButtonClick={this.cancelButtonClick}
					onHideControlsClick={this.onHideControlsClick}
					hintCtaClick={this.hintCtaClick}
				/>
			</Fragment>
		);
	}

}

const mapStateToProps = state => {
	return {
		appState: state.app.appState,
		prevAppState: state.app.prevAppState,
		targetType: state.app.targetType,
		origin: state.app.origin,
		step: state.introStep.step,
		stepCount: state.app.stepCount,
		isNewStep: state.introStep.isNewStep,
		stepItem: state.app.stepItem,
		isChange: state.app.isChange,
		stepChanges: state.app.stepChanges,
		triggerChanges: state.app.triggerChanges,
		mobileMenuChanges: state.app.mobileMenuChanges,
		urlVarExamplesChanges: state.app.urlVarExamplesChanges,
		stepChangingInProgress: state.app.stepChangingInProgress,
		stepAddedRemovedHist: state.app.stepAddedRemovedHist,
		totalSavedChanges: state.app.totalSavedChanges,
		controlsPosition: state.app.controlsPosition,
		mobileMenuOpenerSelected: state.app.mobileMenuOpenerSelected,
		mobileAltStepMode: state.app.mobileAltStepMode,
		isTargetDetailOpened: state.app.isTargetDetailOpened,
		isInteractionDetailOpened: state.app.isInteractionDetailOpened,
		cancelButtonAltPos: state.app.cancelButtonAltPos
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setAppState: (appState) => dispatch({ type: actionTypes.SET_APP_STATE, appState: appState }),
		setStepData: (data) => dispatch({ type: actionTypes.SET_INTRO_STEP_DATA, data: data }),
		setCurrentCoreElement: (stepItem) => dispatch({ type: actionTypes.SET_CURRENT_STEP_CORE, stepItem: stepItem }),
		setStepProp: (name, val) => dispatch({ type: actionTypes.SET_INTRO_STEP_PROP, propName: name, propVal: val }),
		addChange: (targetType, id, change) => dispatch({ type: actionTypes.ADD_CHANGE, targetType: targetType, id: id, change: change }),
		setStepCount: (stepCount) => dispatch({ type: actionTypes.SET_STEP_COUNT, stepCount: stepCount }),
		setStepChangingInProgress: (stepChangingInProgress) => dispatch({ type: actionTypes.STEP_CHANGING_IN_PROGRESS, stepChangingInProgress: stepChangingInProgress }),
		onNewStepAddedAt: (stepIdx, newStepCount) => dispatch({ type: actionTypes.ON_ADD_NEW_STEP_AT, stepIdx: stepIdx, newStepCount: newStepCount }),
		onStepRemovedAt: (stepIdx, oldStepCount) => dispatch({ type: actionTypes.ON_REMOVE_STEP_AT, stepIdx: stepIdx, oldStepCount: oldStepCount }),
		saveChanges: (tourId, stepChanges, triggerChanges, urlVarExamplesChanges, stepAddedRemovedHist, onSuccess, onError) => dispatch(actions.saveChanges(tourId, stepChanges, triggerChanges, urlVarExamplesChanges, stepAddedRemovedHist, onSuccess, onError)),
		deleteTourPost: (tourId, forceDelete, onSuccess, onError) => dispatch(actions.deleteTourPost(tourId, forceDelete, onSuccess, onError)),

		isUrlValidApiReq: (url, onSuccess, onError) => dispatch(actions.isUrlValid(url, onSuccess, onError)),
		sendAskForRatingFeedbackToDP: (type, onSuccess, onError) => dispatch(actions.sendAskForRatingFeedbackToDP(type, onSuccess, onError)),
		setTargetType: (targetType) => dispatch({ type: actionTypes.SET_TARGET_TYPE, targetType: targetType }),
		setOrigin: (origin) => dispatch({ type: actionTypes.SET_ORIGIN, origin: origin }),
		setTotalSavedChanges: (totalSavedChanges, increment = false) => dispatch({ type: actionTypes.SET_TOTAL_SAVED_CHANGES, totalSavedChanges: totalSavedChanges, increment: increment }),
		updateHint: (hintConfig) => dispatch({ type: actionTypes.UPDATE_HINT, hintConfig: hintConfig }),
		closeHint: () => dispatch({ type: actionTypes.CLOSE_HINT }),
		setControlsPosition: (controlsPosition) => dispatch({ type: actionTypes.SET_CONTROLS_POSITION, controlsPosition: controlsPosition }),
		setMobileMenuOpenerSelected: (mobileMenuOpenerSelected) => dispatch({ type: actionTypes.SET_MOBILE_MENU_OPENER_SELECTED, mobileMenuOpenerSelected: mobileMenuOpenerSelected }),
		setMobileAltStepMode: (mobileAltStepMode) => dispatch({ type: actionTypes.SET_MOBILE_ALT_STEP_MODE, mobileAltStepMode: mobileAltStepMode }),
		setNavigButtonHoveredState: (id, hoverIn) => dispatch({ type: actionTypes.UPDATE_NAVIG_BUTTON_HOVERED, id: id, hoverIn: hoverIn }),
		updateTargetDetailOpened: (isOpened) => dispatch({ type: actionTypes.UPDATE_TARGET_EDIT_DETAIL_OPENED, isOpened: isOpened }),
		updateInteractionDetailOpened: (isOpened) => dispatch({ type: actionTypes.UPDATE_INTERACTION_EDIT_DETAIL_OPENED, isOpened: isOpened }),
		setCancelButtonAltPos: (position) => dispatch({ type: actionTypes.SET_CANCEL_BUTTON_POS, position: position })
	};
};

export default /*hot(module)(*/connect(mapStateToProps, mapDispatchToProps)(App)/*)*/;